// POST /sales-crm/filters – zapis zestawu filtrów

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';
import { getSalesCrmFiltersQueryKey } from 'api/endpoints/useGetSalesCrmFilters';

export interface IPostSalesCrmFiltersRequest {
  component_symbol: string;
  name: string;
  filters: IWiseTableAdvancedFilter[];
  /** Widoczność kolumn – zapis wspólnie z filtrami. */
  column_visibility?: Record<string, boolean>;
  /** Kolejność kolumn (field_symbol) – zapis wspólnie z ustawieniami. */
  column_order?: string[];
}

type IResponse = ICommandResponseSuccess;

const postSalesCrmFilters = (data: IPostSalesCrmFiltersRequest): Promise<IResponse> =>
  axios.post('/sales-crm/filters', data);

export const usePostSalesCrmFilters = (
  componentSymbol: string,
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmFiltersRequest>
) => {
  const queryClient = useQueryClient();
  return useMutation(
    (data: IPostSalesCrmFiltersRequest) => postSalesCrmFilters(data),
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries(getSalesCrmFiltersQueryKey(componentSymbol));
        options?.onSuccess?.(...args);
      }
    }
  );
};
